import Dialog from '@/components/_common/Dialog';
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { IconButton, SxProps } from '@mui/material';
import React, { useState } from 'react';

interface DeleteRowButtonProps {
  onClick: () => void;
  confirmation?: boolean;
  sx?: SxProps;
}

const DeleteRowButton = ({ onClick, confirmation = false, sx }: DeleteRowButtonProps) => {
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (confirmation) setDeleteConfirm(true);
    else onClick();
  };

  return (
    <>
      <StyledIconButton onClick={handleClick} sx={sx}>
        <PolarisIcon icon="delete" height={15} />
      </StyledIconButton>
      {confirmation && (
        <Dialog
          open={deleteConfirm}
          title="Are you sure you want to delete this job?"
          submitText="Yes, delete this job"
          onSubmit={onClick}
          cancelText="Cancel"
          maxWidth={480}
          onCancel={() => setDeleteConfirm(false)}
        >
          The job will be removed from your order.
        </Dialog>
      )}
    </>
  );
};

export default DeleteRowButton;

const StyledIconButton = styled(IconButton)`
  border-color: ${({ theme }) => theme.palette.primary?.main};
  border-width: 1.5px;
  border-style: solid;
  padding: ${({ theme }) => theme.spacing(0.75)};
  border-radius: 30px;
  display: flex;
  justify-content: center;
  opacity: 0.8;
  transition: ease opacity 300ms;
  &.Mui-disabled {
    opacity: 0.3;
  }
  &:hover {
    opacity: 1;
    transition: ease opacity 300ms;
  }
  & svg {
    color: ${({ theme }) => theme.palette.primary?.main};
  }
`;
